module.exports = __webpack_public_path__ + "img/offical2.ee77737c.png";